import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Accordian, CheckRadio, RightArrowIcon } from "components";
import { useState } from "react";

export const ChecklistLibraryAccordian = ({
  checklist,
  isSelected,
  onSelectionChange,
}: {
  checklist: any;
  isSelected?: boolean;
  onSelectionChange: (isSelected: boolean) => void;
}) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <Accordian
      key={checklist?.mapping_id}
      title={checklist.checklist_title}
      expanded={isExpanded}
      accordianContainerStyles={{
        borderBottom: "none",
        backgroundColor: isSelected
          ? theme.palette.primitive.system.green[15]
          : theme.palette.darkBg.high,
        "&.MuiAccordion-root": {
          "&:before": {
            display: "none",
          },
          border: `1px solid ${theme.palette.neutral["020"]}`,
          borderRadius: "8px",
          overflow: "hidden",
        },
        "& .MuiAccordionSummary-root.Mui-expanded": {
          borderBottom: "none",
        },
        "&.Mui-expanded": {
          borderBottom: "none",
        },
        padding: "0px",
      }}
      expandIcon={<></>}
      titleContent={
        <Stack
          direction={"row"}
          onClick={(e) => {
            e.stopPropagation();
            onSelectionChange(!isSelected);
          }}
          sx={{
            width: "100%",
            alignItems: "center",
            gap: "8px",
            flex: 1,
          }}
        >
          <Stack
            sx={{
              transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
              height: "fit-content",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
          >
            <RightArrowIcon
              sx={{
                fontSize: "20px",
              }}
            />
          </Stack>
          <Box flex={1}>
            <Typography variant="subtitle1">
              {checklist.checklist_title}
            </Typography>
          </Box>

          <CheckRadio
            status={isSelected ? "checked" : "unchecked"}
            onClick={() => {
              onSelectionChange(!isSelected);
            }}
            sx={{
              width: "16px",
              height: "16px",
            }}
          />
        </Stack>
      }
      accordianSummaryStyles={{
        "&.MuiAccordionSummary-root": {
          padding: "0px 16px",
        },
        width: "100%",
      }}
      accordianDetailsStyles={{}}
    >
      <Stack
        sx={{
          width: "100%",
          p: "0px 16px 16px 48px",
          gap: "16px",
        }}
      >
        {checklist.items.map((item: any) => (
          <Box key={item.item_id}>
            <Typography
              key={item.item_id}
              variant="body-small"
              sx={{
                flex: 1,
              }}
            >
              {item.checklist_item_name}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Accordian>
  );
};
